<template>
  <div v-if="!isLoggedIn && allowViewPass && isValidPass">
    <div class="action-container">
      <LandingHeader
        :isToVerifyIdentity="isToVerifyIdentity"
        :isUserInvited="isUserInvited"
        :companyName="companyName"
        :companyLogo="companyLogoUrl"
        :requestAccess="requestAccess"
        :passIntro="passIntro"
        :passName="passName"
        :isRequestNeedsApproval="isRequestNeedsApproval"/>

      <div>
        <br/>
        <br/>
      </div>

      <p v-if="inviteToken !== undefined">
        <a v-bind:href="'/login?t=' + inviteToken  + '&page_origin=' + originUrl">Login</a> or
        <a v-bind:href="'/create-account?t=' + inviteToken  + '&page_origin=' + originUrl">
          Create account
        </a>
        <br>to get your YeyPass.
      </p>
      <p v-else>
        <a v-bind:href="'/login?page_origin=' + originUrl">Login</a> or
        <a v-bind:href="'/create-account?page_origin=' + originUrl">Create account</a>
        <br>to get your YeyPass.
      </p>
    </div>
  </div>
</template>

<script>
import LandingHeader from '@/components/pass_share/LandingHeader'

export default {
  name: 'not-logged-in',
  components: {
    LandingHeader
  },
  props: {
    companyName: {
      type: String,
      default: ''
    },
    companyLogoUrl: {
      type: String,
      default: ''
    },
    inviteToken: {
      type: String,
      default: ''
    },
    originUrl: {
      type: String,
      default: ''
    },
    passIntro: {
      type: String,
      default: ''
    },
    passName: {
      type: String,
      default: ''
    },
    load404Message: {
      type: String,
      default: ''
    },
    requestAccess: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isValidPass: {
      type: Boolean,
      default: false
    },
    isUserInvited: {
      type: Boolean,
      default: false
    },
    isRequestAccessAllowed: {
      type: Boolean,
      default: false
    },
    isToVerifyIdentity: {
      type: Boolean,
      default: false
    },
    isRequestNeedsApproval: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    haveInviteToken() {
      return this.inviteToken !== '' && this.inviteToken !== undefined
    },
    allowViewPass() {
      return this.isRequestAccessAllowed || this.haveInviteToken
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/share/passes/NotLoggedIn.vue